import React from "react";
import useStyles from "./styles";
import ApmPayButton from '../ApmPayButton';

const WechatPay = ({ currentPaymentSystem, errorString }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <ApmPayButton currentPaymentSystem={currentPaymentSystem} errorString={errorString} />
    </div>
  )
};

export default WechatPay
